import AuthGuardDisplay from '@components/AuthGuardDisplay';
import styled from '@emotion/styled';
import useCart from '@hooks/cart/useCart';
import CartLine from '@icons/CartLine';
import { Link } from '@router/Link';

interface Props {
    shopId: string;
}

function CartButton({ shopId }:Props) {
  const cart = useCart(shopId);
  const cartCount = cart?.items
    .reduce((acc, cur) => acc + cur.qty, 0) || 0;
  return (
      <AuthGuardDisplay>
          <Link activityName="CartActivity"
                activityParams={{ shopId }}>
              <Container>
                  <CartLine />
                  {(cartCount !== 0) && (
                      <Count>
                          {cartCount}
                      </Count>
                  )}
              </Container>
          </Link>
      </AuthGuardDisplay>
  );
}

const Container = styled.div`
    position: relative;
`;

const Count = styled.div`
    position: absolute;
    background-color: var(--color-red);
    width: 14px;
    height: 14px;
    border-radius: 10px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    top: 0;
    right: -4px;
`;

export default CartButton;
